export default __webpack_public_path__ + "static/media/Technical Textiles 2.6505eece.jpg";